var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-top"},[_c('div',{staticClass:"secondary-c tw-p-6"},[_c('i',{class:`fa fa-${_vm.icon} tw-inline tw-text-lg`,attrs:{"aria-hidden":"true"}}),_c('h2',{staticClass:"tw-inline tw-font-bold tw-text-base tw-ml-4"},[_vm._v(_vm._s(_vm.text))]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }